import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h } from 'preact';

import PartyPill from './PartyPill';
import PureComponent from './PureComponent';

// internal
import {
  sort_candidates_by_party,
  changePartyName,
} from '../utils/election-utils';

interface Props {
  partyName: string;
  partyBallot: { [key: string]: any };
  renderCandidate: any;
}

class EachPartyColumn extends Component<Props> {
  render() {
    const { partyName, partyBallot, renderCandidate } = this.props;

    let get_candidates = partyBallot.values;

    let candidates = get_candidates.map((candidate: any) => candidate);

    const rowClass = cx('seat__race', {
      'seat__race--Democrat': partyName == 'Democratic',
      'seat__race--Republican': partyName == 'Republican',
    });

    return (
      <div class={rowClass}>
        <div class="race">
          <h4 class="race__title">{changePartyName(partyName)}</h4>
          <table class="contest__candidates">
            <thead>
              <tr>
                <th scope="col" class="contest__candidate-header" colspan="2">
                  Candidates
                </th>
              </tr>
            </thead>
            <tbody>
              {candidates.map((candidate: any) => renderCandidate(candidate))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

EachPartyColumn.defaultProps = {};

export default EachPartyColumn;
